import { BASE_DOC_URL_VB, FIELD_KEYS } from 'app/developer-v3/constants';

const fieldPagination = {
  label: 'Pagination',
  key: FIELD_KEYS.canPaginate,
  type: 'boolean-input',
  helpText: `Support Paging must only be enabled if the trigger is to be used for a dynamic dropdown or in Transfer; and the endpoint can paginate data. You must also include the <code>{{bundle.meta.page}}</code> value in the API options above. <a target="_blank" href="${BASE_DOC_URL_VB}/build/pagination-trigger">Learn More</a>.`,
  boolHelpText: 'Support Paging',
};

const formFields = {
  polling: [
    {
      label: 'API Endpoint',
      key: FIELD_KEYS.perform,
      type: 'request-editor',
      required: true,
      helpText: `Enter the URL Zapier will poll for new items. <strong>This request must return an array</strong>. <a href="${BASE_DOC_URL_VB}/build/trigger#1-polling-trigger" target="_blank">Learn more</a>. Polling occurs per live Zap every 1 to 15 minutes, depending on <a href="https://zapier.com/pricing" target="_blank">user's Zapier plan level</a>.`,
    },
    fieldPagination,
  ],
  hook: [
    {
      label: 'Subscribe',
      key: FIELD_KEYS.performSubscribe,
      type: 'request-editor',
      helpText: 'Enter the endpoint URL to create a new webhook subscription.',
    },
    {
      label: 'Unsubscribe',
      key: FIELD_KEYS.performUnsubscribe,
      type: 'request-editor',
      helpText: 'Enter the endpoint URL to remove a webhook subscription.',
    },
    {
      label: 'Perform List',
      key: FIELD_KEYS.performList,
      type: 'request-editor',
      helpText: `Enter the endpoint URL Zapier should check for recent items, to provide sample data in the Zap Editor. <strong>This request must return an array</strong>. <a href="${BASE_DOC_URL_VB}/build//hook-trigger#perform-list" target="_blank">Learn more</a>. Required for <a href="${BASE_DOC_URL_VB}/quickstart/private-vs-public-integrations" target="_blank">public apps</a> with a REST Hook trigger.`,
    },
    fieldPagination,
    {
      label: 'Perform',
      key: FIELD_KEYS.perform,
      type: 'code-editor',
      required: true,
      helpText: `The perform function is called each time a new hook is received. Make any needed changes to the data before it's returned to the Zap. <strong>This request must return an array</strong>. <a href="${BASE_DOC_URL_VB}/build/hook-trigger#perform" target="_blank">Learn more</a>.`,
      extraProps: {
        defaultCode: `return [bundle.cleanedRequest];`,
      },
    },
  ],
};

export default formFields;
